import {
  IAuthTokenFactory,
  IAuthTokenOptions,
  IAuthTokenStore,
  ISerializedAuthToken,
} from '@portal/env/stores/authTokens/authTokenTypes';
import { SourceTokenDebugger } from '@portal/env/stores/authTokens/TokenDebugger';
import { DateTime } from 'luxon';
import { ServerCookies } from '@portal/env/utils/serverCookies';
import {
  NEXUDUS_TOKEN_COOKIE_NAME,
  NEXUDUS_TOKEN_EXPIRY_NAME,
} from '@portal/env/stores/authTokens/consts';
import { NexudusTokenStore } from '@portal/env/stores/authTokens/nexudusTokenStore';

export class NexudusTokenStoreFactory implements IAuthTokenFactory {
  createEmpty(options?: IAuthTokenOptions): IAuthTokenStore {
    const tokenDebugger =
      options?.debugger?.forSource('nexudusToken') ||
      new SourceTokenDebugger('nexudusToken');
    tokenDebugger.addEvent({
      action: 'createdEmpty',
      message: 'Created empty NexudusTokenStore',
    });

    return new NexudusTokenStore(null, null, options?.wallClock, tokenDebugger);
  }

  createOnClient(
    fromServer: ISerializedAuthToken,
    options?: IAuthTokenOptions,
  ): IAuthTokenStore {
    const tokenDebugger =
      options?.debugger?.forSource('nexudusToken') ||
      new SourceTokenDebugger('nexudusToken');

    const expiry = fromServer.expiryDate
      ? DateTime.fromISO(fromServer.expiryDate)
      : null;
    return new NexudusTokenStore(
      fromServer.token,
      expiry,
      options?.wallClock,
      tokenDebugger,
    );
  }

  createOnServer(
    cookies: ServerCookies,
    options?: IAuthTokenOptions,
  ): IAuthTokenStore | undefined {
    const tokenDebugger =
      options?.debugger?.forSource('nexudusToken') ||
      new SourceTokenDebugger('nexudusToken');

    const value = cookies.getValueOf(NEXUDUS_TOKEN_COOKIE_NAME);
    const expiryString = cookies.getValueOf(NEXUDUS_TOKEN_EXPIRY_NAME);
    const expiry = expiryString ? DateTime.fromISO(expiryString) : null;

    if (value) {
      tokenDebugger.addEvent({
        action: 'loadedFromCookie',
        message: 'Loaded from cookie',
      });
    } else {
      tokenDebugger.addEvent({
        action: 'createdEmpty',
        message: 'Created empty NexudusTokenStore',
      });
    }

    return new NexudusTokenStore(
      value || null,
      expiry,
      options?.wallClock,
      tokenDebugger,
    );
  }
}
